import { clienteApi } from '../../common/axios';

const TOKEN_KEY = 'cliente_token';
const USER_KEY = 'cliente_user';

const clienteAuthService = {
  login: async (email, password) => {
    const res = await clienteApi.post('/cliente/login', { email, password });
    localStorage.setItem(TOKEN_KEY, res.data.token);
    localStorage.setItem(USER_KEY, JSON.stringify(res.data.user));
    return res.data;
  },

  register: async (data) => {
    const res = await clienteApi.post('/cliente/register', data);
    localStorage.setItem(TOKEN_KEY, res.data.token);
    localStorage.setItem(USER_KEY, JSON.stringify(res.data.user));
    return res.data;
  },

  logout: async () => {
    try {
      await clienteApi.post('/cliente/logout');
    } finally {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(USER_KEY);
    }
  },

  getCurrentUser: () => {
    const u = localStorage.getItem(USER_KEY);
    return u ? JSON.parse(u) : null;
  },

  setCurrentUser: (user) => {
    if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
  },

  isAuthenticated: () => !!localStorage.getItem(TOKEN_KEY),

  forgotPassword: async (email) => {
    const res = await clienteApi.post('/cliente/forgot-password', { email });
    return res.data;
  },

  resetPassword: async (token, email, password, password_confirmation) => {
    const res = await clienteApi.post('/cliente/reset-password', { token, email, password, password_confirmation });
    return res.data;
  },

  changePassword: async (current_password, password, password_confirmation) => {
    const res = await clienteApi.put('/cliente/password', { current_password, password, password_confirmation });
    return res.data;
  },
};

export default clienteAuthService;
